import React from 'react';
import PropTypes from 'prop-types';
import * as Sentry from '@sentry/react';
import { useNavigate } from 'react-router-dom';
import { buildDrillDownStopState, ROUTES, FEATURES, useWhiteLabelConfig, UserUtils } from '@cyberint/common-utils';
import { MAIN_TABS } from '../../../constants';
import { t } from '../../../i18n';

const UserDetails = ({ user, signOut, onClick, onClickContactAdmin, environmentCustomerId, features }) => {
  const { whiteLabelConfig, isNonWhiteLabel } = useWhiteLabelConfig();
  const navigate = useNavigate();

  const goToProfile = event => {
    onClick?.(event);
    event.preventDefault();
    const path = features?.includes(FEATURES.MY_ACCOUNT_FEATURE)
      ? MAIN_TABS.USER_SETTINGS.path
      : `/${ROUTES.MY_PROFILE}`;
    navigate(path, {
      state: buildDrillDownStopState({ userToUpdate: user, customerId: environmentCustomerId })
    });
  };

  const callSignOut = () => {
    Sentry.addBreadcrumb({
      category: 'auth',
      message: 'User logged off explicitly',
      level: 'info'
    });
    signOut();
  };

  const {
    links: { customerSupport }
  } = whiteLabelConfig;

  const customerSupportLink = isNonWhiteLabel
    ? `${customerSupport}?username=${user.fullname}&email=${user.username}&company=${user.customer.name}`
    : customerSupport;

  const showContactMyAdmin = UserUtils.isNonAdmin(user);

  return (
    <div className="user-details-container">
      <div className="details">
        <div className="name"> {user.fullname}</div>
        <div className="email">{user.username}</div>
      </div>
      <div className="actions">
        <div className="user-panel-menu-item" onClick={goToProfile}>
          {MAIN_TABS.USER_SETTINGS.title}
        </div>
        {showContactMyAdmin && (
          <div className="user-panel-menu-item" onClick={onClickContactAdmin}>
            {t('topbar.contactMyAdmin')}
          </div>
        )}
        <a
          className="user-panel-menu-item"
          href={customerSupportLink}
          onClick={onClick}
          target="_blank"
          rel="noopener noreferrer">
          {t('topbar.customer-support')}
        </a>
        <div className="logout" onClick={callSignOut}>
          {t('topbar.logout')}
        </div>
      </div>
    </div>
  );
};

UserDetails.propTypes = {
  user: PropTypes.object.isRequired,
  onClick: PropTypes.func.isRequired,
  onClickContactAdmin: PropTypes.func.isRequired,
  signOut: PropTypes.func.isRequired,
  environmentCustomerId: PropTypes.string,
  features: PropTypes.arrayOf(PropTypes.string)
};

export default UserDetails;
